<template>
  <b-modal
    id="edit-assembly-area-modal"
    title="Assembly Area Update Modal"
    centered
    hide-footer
    size="lg"
    @hidden="reset"
    :no-close-on-esc="true"
    :no-close-on-backdrop="true"
  >
    <template #modal-title>
      <h2 class="m-0">Assembly Area Update</h2>
    </template>
    <validation-observer ref="assembly_areaCreateFormValidation">
      <b-form @submit.prevent enctype="multipart/form-data">
        <b-form-group label-for="site">
          <template #label>
            Site <span class="text-danger">*</span>
          </template>
          <v-select
            label="name"
            v-model="site"
            placeholder="Select Site"
            :options="sites"
            autoscroll
            :clearable="true"
            @input="fetchBuildings()"
            required
          ></v-select>
        </b-form-group>


        <b-form-group label-for="building">
          <template #label>
            Building <span class="text-danger">*</span>
          </template>
          <v-select
            label="name"
            v-model="building"
            placeholder="Select Building"
            :options="buildings"
            autoscroll
            :clearable="true"
            required
          ></v-select>
        </b-form-group>


        <b-form-group label-for="area_type">
          <template #label>
            Area Type <span class="text-danger">*</span>
          </template>
          <v-select
            label="name"
            v-model="area_type"
            placeholder="Select Area Type"
            :options="area_types"
            autoscroll
            :clearable="true"
            required
          ></v-select>
        </b-form-group>


        <!-- Address Input Field -->
        <b-form-group label-for="address">
          <template #label>
            Address <span class="text-danger">*</span>
          </template>
          <b-form-input
            id="autocomplete-edit"
            v-model="address"
            placeholder="Enter your address"
            required
          />
        </b-form-group>

        <b-form-group class="mt-2 text-right">
          <b-button
            type="submit"
            variant="primary"
            pill
            class="mr-1"
            @click="submit"
          >
            Update
          </b-button>
          <b-button
            type="reset"
            variant="outline-secondary"
            @click="reset"
            pill
          >
            Reset
          </b-button>
        </b-form-group>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { required } from "@validations";
import util from "@/util.js";
import { quillEditor } from "vue-quill-editor";
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";


export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    quillEditor,
  },
  props: {assembly_area:Object},
  mixins: [util],
  data() {
    return {
      required,      
      regex: /^[a-zA-Z ]*$/,
      sites: [],
      site: "",
      buildings: [],
      building: "",
      latitude: "",
      longitude: "",      
      address: "",
      area_types: [
        { name:"Primary", id:"Primary" },
        { name:"Secondary", id:"Secondary" },
      ],
      area_type: "",    
    };
  },
  methods: {
    ...mapActions({
      updateAssemblyArea: "appData/updateAssemblyArea",
      getSitesDDL: "appData/getSitesDDL",
      getBuildingsDDL: "appData/getBuildingsDDL",
    }),

    async submit() {
      try {
        const formData = new FormData();        
        formData.append("building", this.building.id);
        formData.append("area_type", this.area_type.id);
        formData.append("address", this.address);
        formData.append("latitude", this.latitude);
        formData.append("longitude", this.longitude);
        formData.append("updated_by", this.getLoggedInUser.id);

        const res = await this.updateAssemblyArea({
          payload: formData,
          pk: this.assembly_area.id
        });
        if (res.status === 200) {
          this.$toast(
            {
              component: ToastificationContent,
              props: {
                title: "Assembly Area Updated Successfully",
                variant: "success",
                icon: "BellIcon",
              },
            },
            {
              position: "top-right",
            }
          );
          this.reset();
          this.$nextTick(() => {
            this.$bvModal.hide("edit-assembly-area-modal");
          });
          this.$emit("modalClosed");
        }
      } catch (error) {
        this.displayError(error);
      }
    },


    async fetchBuildings(){
      const buildings =  await this.getBuildingsDDL();
      this.buildings = buildings.data;
      this.building = "";
       if (!this.site) {
        this.buildings = [];
        return;
      }
      this.buildings = this.buildings.filter(building => building.site === this.site.id);      
    },

    initAutocomplete() {
      const input = document.getElementById('autocomplete-edit');
      const autocomplete = new google.maps.places.Autocomplete(input);

      autocomplete.addListener('place_changed', () => {
        const place = autocomplete.getPlace();
        if (!place.geometry) {
          console.log('Returned place contains no geometry');
          return;
        }
        this.address = place.formatted_address;
        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
      });
    },

    reset() {
      this.name = "";
      this.location = "";
      this.description = "";
      this.files = null;
      this.status = "";
    },
  },
  computed: {
    ...mapGetters({ getLoggedInUser: "appData/getLoggedInUser" }),
  },
  async mounted(){
    const sites =  await this.getSitesDDL();
    this.sites = sites.data;

    const buildings =  await this.getBuildingsDDL();
    this.buildings = buildings.data;

    if(this.assembly_area)
    {
      this.building = this.buildings.find(b => b.id === this.assembly_area.building);
      this.site = this.sites.find(s => s.id === this.building.site);
      this.area_type = this.area_types.find(a => a.id === this.assembly_area.area_type);
      this.address = this.assembly_area.address;
      this.latitude = this.assembly_area.latitude;
      this.longitude = this.assembly_area.longitude;
    }
    this.initAutocomplete();
  },
};
</script>

<style>
.pac-container {
  z-index: 1051 !important; 
}
</style>
